var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tree',{ref:"ElTreeDict",attrs:{"data":_vm.options,"props":_vm.setting},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(slot,key){return {key:key,fn:function(scope){return [_vm._t(key,null,null,scope)]}}})],null,true)},[_vm._l((_vm.$slots),function(slot,key){return _c('template',{slot:key},[_vm._t(key)],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }